import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

//获取执业医师类新闻
export const findZhiYeNews = ({ chID, coID }) => {
    return request('/news/zhiye', 'get', { chID, coID })
}
//获取执业护士类新闻
export const findHuShiNews = ({ chID, coID }) => {
    return request('/news/hushi', 'get', { chID, coID })
}

//获取执业药师类新闻
export const findYaoShiNews = ({ chID, coID }) => {
    return request('/news/zhiyeyaoshi', 'get', { chID, coID })
}
//获取执业兽医类新闻
export const findShouYiNews = ({ chID, coID }) => {
    return request('/news/shouyi', 'get', { chID, coID })
}

//获取专长类新闻
export const findZhuanChangNews = ({ chID, coID, clID }) => {
    return request('/news/zhuanchang', 'get', { chID, coID, clID })
}
//获取初级类新闻
export const findChuJiNews = ({ chID }) => {
    return request('/news/chuji', 'get', { chID })
}

//获取中级类新闻
export const findZhongJiNews = ({ chID }) => {
    return request('/news/zhongji', 'get', { chID })
}
//获取副高类新闻
export const findFuGaoNews = ({ chID }) => {
    return request('/news/fugao', 'get', { chID })
}
//获取正高类新闻
export const findZhengGaoNews = ({ chID }) => {
    return request('/news/zhenggao', 'get', { chID })
}
//获取规培类新闻
export const findGuiPeiNews = ({ chID }) => {
    return request('/news/guipei', 'get', { chID })
}
//获取考研类新闻
export const findKaoYanNews = ({ chID, coID }) => {
    return request('/news/kaoyan', 'get', { chID, coID })
}
//获取招聘类新闻
export const findZhaoPinNews = ({ chID }) => {
    return request('/news/zhaopin', 'get', { chID })
}
//获取设备类新闻
export const findSheBeiNews = ({ chID }) => {
    return request('/news/shebei', 'get', { chID })
}

//获取每个新闻页面中出现的两个视频推荐
export const findNewsVideo = ({ clID }) => {
    return request('/news/video', 'get', { clID })
}

//获取每个新闻页面中出现的两个题库推荐
export const findNewsTests = ({ clID }) => {
    return request('/news/tests', 'get', { clID })
}

//获取新闻详情
export const findNewsDetail = (id) => {
    return request('/news/newsdetail', 'get', { id })
}

//随机获取news首页新闻
export const findRandomNews = ({ limit }) => {
    return request('/news/random', 'get', { limit })
}

//从新闻页面点击查看考试大纲列表
export const findLineList = (clID) => {
    return request('/outline/linelist', 'get', { clID })
}
//从新闻页面点击查看考试大纲详情
export const findLineDetail = (lineID) => {
    return request('/outline/linedetail', 'get', { lineID })
}

//从新闻页面点击查看报考指导详情
export const findGuideList = ({ clID, size, page }) => {
    return request('/guide/guidelist', 'get', { clID, size, page })
}

//从新闻页面点击查看报考指导预览
export const findGuideView = (guID) => {
    return request('/guide/guideview', 'get', { guID })
}

//从新闻页面点击查看报考指导详情
export const findAdviceList = ({ clID, size, page }) => {
    return request('/advice/advicelist', 'get', { clID, size, page })
}
//从新闻页面点击查看备考建议预览
export const findAdviceView = (advID) => {
    return request('/advice/adviceview', 'get', { advID })
}

//从新闻页面点击查看报考指导列表
export const findGuideItem = ({ chID, coID, clID, size, page }) => {
    return request('/guide/guideitem', 'get', { chID, coID, clID, size, page })
}

//从新闻页面点击查看考试指导详情
export const findGuideDetail = (guID) => {
    return request('/guide/guidedetail', 'get', { guID })
}

//从新闻页面点击查看官方政策列表
export const findNewsPolicy = ({ chID, coID, clID, size, page }) => {
    return request('/news/policy', 'get', { chID, coID, clID, size, page })
}

//从新闻页面点击查看重要通知列表
export const findNewsNotice = ({ chID, coID, clID, size, page }) => {
    return request('/news/notice', 'get', { chID, coID, clID, size, page })
}

//从新闻页面点击查看新闻资讯列表
export const findNewsList = ({ chID, coID, clID, size, page }) => {
    return request('/news/newslist', 'get', { chID, coID, clID, size, page })
}


//从新闻页面点击查看考试大纲列表
export const findLineItem = ({ chID, coID, clID, size, page }) => {
    return request('/outline/lineitem', 'get', { chID, coID, clID, size, page })
}

//从新闻页面点击查看备考指南列表
export const findAdviceItem = ({ chID, coID, clID, size, page }) => {
    return request('/advice/adviceitem', 'get', { chID, coID, clID, size, page })
}

//从新闻页面点击查看备考指南详情
export const findAdviceDetail = (advID) => {
    return request('/advice/advicedetail', 'get', { advID })
}

//随机获取news首页新闻
export const findTimeLine = ({ limit }) => {
    return request('/news/timeline', 'get', { limit })
}

//获取执业banner
export const findNewsBanner = ({ chID, coID, clID }) => {
    return request('/news/banner', 'get', { chID, coID, clID })
}